import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield, ArrowLeft } from 'lucide-react';

export default function PrivacyPage() {
  return (
    <div className="container py-8 px-4 md:px-6">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-4 mb-8">
          <Button variant="ghost" size="icon" asChild>
            <Link to="/">
              <ArrowLeft className="h-5 w-5" />
            </Link>
          </Button>
          <div>
            <h1 className="text-3xl font-bold">Privacy Policy</h1>
            <p className="text-muted-foreground">Last updated: March 1, 2025</p>
          </div>
        </div>

        <Card className="mb-8">
          <CardHeader>
            <div className="flex items-center gap-2">
              <Shield className="h-5 w-5 text-primary" />
              <CardTitle>Your Privacy Matters</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="prose dark:prose-invert max-w-none">
            <p>
              At NewLoop, we take your privacy seriously. This Privacy Policy explains how we collect,
              use, disclose, and safeguard your information when you use our platform.
            </p>

            <h2>Information We Collect</h2>
            <h3>Personal Information</h3>
            <p>We collect information that you provide directly to us, including:</p>
            <ul>
              <li>Name and contact information</li>
              <li>Professional experience and education</li>
              <li>Skills and qualifications</li>
              <li>Profile information and preferences</li>
              <li>Communication preferences</li>
            </ul>

            <h3>Usage Information</h3>
            <p>We automatically collect certain information about your device and usage, including:</p>
            <ul>
              <li>Device information and identifiers</li>
              <li>Usage patterns and preferences</li>
              <li>Log data and analytics</li>
              <li>Location information (if enabled)</li>
            </ul>

            <h2>How We Use Your Information</h2>
            <p>We use the collected information for various purposes, including:</p>
            <ul>
              <li>Providing and improving our services</li>
              <li>Personalizing your experience</li>
              <li>Processing job applications</li>
              <li>Communicating with you</li>
              <li>Analyzing and optimizing our platform</li>
              <li>Ensuring security and preventing fraud</li>
            </ul>

            <h2>Information Sharing</h2>
            <p>We may share your information with:</p>
            <ul>
              <li>Employers and recruiters (with your consent)</li>
              <li>Service providers and partners</li>
              <li>Legal authorities when required</li>
            </ul>

            <h2>Your Rights and Choices</h2>
            <p>You have certain rights regarding your personal information:</p>
            <ul>
              <li>Access and update your information</li>
              <li>Control your privacy settings</li>
              <li>Opt-out of communications</li>
              <li>Request data deletion</li>
            </ul>

            <h2>Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal
              information. However, no method of transmission over the Internet is 100% secure.
            </p>

            <h2>Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes by
              posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>

            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:privacy@newloop.dev">privacy@newloop.dev</a>.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}